import { create } from 'zustand'

import { STEP_CONST, STEP_MAP } from '../constants/demoSaleApplication/constant'

type DemoSaleApplicationState = {
  currentState: string
  setCurrentState: (payload: string) => void
}

export const useDemoSaleApplicationState = create<DemoSaleApplicationState>(
  (set) => ({
    currentState: STEP_CONST.APPLICATION_FORM,
    setCurrentState: (payload: string) =>
      set((state) => {
        if (STEP_MAP[state.currentState] <= STEP_MAP[payload])
          return { ...state, currentState: payload }
        else return state
      }),
  })
)
